import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import Posts from '../Posts';
import CurrentSelected from '../CurrentSelected';
import FilterOrderBy from '../filters/FilterOrderBy';

function LayoutPrograms(props) {
  const {
    layout,
    results,
    filters,
    currentSearchTerm,
    selected,
    mobileStyle,
    order,
    posts,
    postsPerRow,
    currentPage,
    maxPages,
    loading,
    acfData,
    postType,
    postTypes,
    paginationStyle,
    filterReset,
    displayPostCounts,
    displaySelected,
    displaySidebar,
    displayExcerpt,
    displayAuthor,
    displayDate,
    displayCategories,
    displayReset,
    displayResults,
    displaySearch,
    displaySort,

    pageNext,
    pagePrev,
    setCurrentPage,
    orderChange,
    toggleSelected,
    replaceSelected,
    addToSelected,
    removeFromSelected,
    isSelected,
    resetSelected,
    searchFieldChange,
    scrollUp,
    isEmpty,
    sidebarClassName,
    setChangedFilter,
    setFilterReset
  } = props;

  let sidebarLeft, sidebarRight, sidebarTop, sidebarContent, sortComponent, resultsElement, resultsText;

  if (displaySort) {
    sortComponent =
      <div className='posts-list__sort'>
        <FilterOrderBy
          order={order}
          orderChange={orderChange}
          postType={postType}
          setCurrentPage={setCurrentPage}
          setChangedFilter={setChangedFilter} 
        ></FilterOrderBy>
      </div>
  }

  if (displaySelected) {
    sidebarTop = <CurrentSelected
      selected={selected}
      filters={filters}

      removeFromSelected={removeFromSelected}
      isEmpty={isEmpty}
    ></CurrentSelected>
  }

  if (results === 1) {
    resultsText = ' Result';
  } else {
    resultsText = ' Results';
  }
  let resultsNum;
  if (results > 100) {
    resultsNum = '100+';
  } else {
    resultsNum = results;
  }
  resultsElement = <p className='posts-list__count'>
    {resultsNum}{resultsText}
  </p>

  if (displaySidebar !== 'false') {
    sidebarContent = <Sidebar
      layout={layout}
      results={resultsNum}
      filters={filters}
      currentSearchTerm={currentSearchTerm}
      selected={selected}
      mobileStyle={mobileStyle}
      order={order}
      sidebarLeft={sidebarLeft}
      sidebarRight={sidebarRight}
      autoLoadFilters={true}
      filterReset={filterReset}
      displayPostCounts={displayPostCounts}
      displayResults={displayResults}
      displayReset={displayReset}
      displaySearch={displaySearch}
      displaySort={displaySort}
      postType={postType}
      orderChange={orderChange}
      toggleSelected={toggleSelected}
      addToSelected={addToSelected}
      replaceSelected={replaceSelected}
      isSelected={isSelected}
      resetSelected={resetSelected}
      searchFieldChange={searchFieldChange}
      setCurrentPage={setCurrentPage}
      setChangedFilter={setChangedFilter}
      setFilterReset={setFilterReset}
    >
    </Sidebar>
  }
  return (
    <div className={`app-layout layout-programs ${sidebarClassName()}`}>
      <div className="container posts-list__container">
        {sidebarTop}
        {sidebarContent}
        <div className="posts-list__content">
          <div className="posts-list__header">
            {resultsElement}
            {sortComponent}
          </div>
          <Posts
            posts={posts}
            postsPerRow={postsPerRow}
            currentPage={currentPage}
            maxPages={maxPages}
            loading={loading}
            order={order}
            acfData={acfData}
            postType={postType}
            postTypes={postTypes}
            paginationStyle={paginationStyle}
            displayExcerpt={displayExcerpt}
            displayAuthor={displayAuthor}
            displayDate={displayDate}
            displayCategories={displayCategories}

            pageNext={pageNext}
            pagePrev={pagePrev}
            setCurrentPage={setCurrentPage}
            orderChange={orderChange}
            replaceSelected={replaceSelected}
            resetSelected={resetSelected}
            scrollUp={scrollUp}
          ></Posts>
        </div>
      </div>
    </div>
  )
}

export default LayoutPrograms;